module.exports = __webpack_public_path__ + "img/loly1.0.15476a6d.jpg";